import React, {FC} from 'react';
import styled, {css, keyframes} from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {Icon} from '../Icon/Icon';
import {IconName} from '../Icon/IconName';
import {ButtonProps} from './Button';
import {LoadingButton} from './LoadingButton';

interface Props extends ButtonProps {
  progressDuration?: number;
  isProgressAnimationPaused?: boolean;
  label: string;
  icon?: IconName;
}

export const ProgressButton: FC<Props> = ({
  progressDuration,
  isProgressAnimationPaused = false,
  label,
  icon,
  ...baseProps
}) => {
  return (
    <ButtonShell
      type="secondary"
      disableShadow
      isLoading={false}
      aria-label={undefined}
      {...baseProps}
    >
      {progressDuration != null ? (
        <Progress
          animationDuration={progressDuration}
          isProgressAnimationPaused={!!isProgressAnimationPaused}
        />
      ) : null}
      {icon && <Icon style={{marginRight: 5}} size={'S'} asset={icon} />}
      {label}
    </ButtonShell>
  );
};

const ButtonShell = styled(LoadingButton)`
  padding: 0.5rem 2.5rem;
  border: 1px solid ${COLORS.Grey3};
  background-color: ${COLORS.White};
  width: 100%;
  height: 42px; // manual override to keep the same height whem isLoading = true
  overflow: visible;

  > span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

// eslint-disable-next-line local-rules/css-layout-animation
const animateWidth = keyframes`
  from {
    width: 0%;
  }

  to {
    width: calc(100% + 2px);
  }
`;

const Progress = styled.div<{
  animationDuration: number;
  isProgressAnimationPaused: boolean;
}>`
  position: absolute;
  bottom: -1px;
  left: -1px;
  width: 0px;
  height: 4px;
  background: ${COLORS.Black};
  animation: ${({animationDuration}) =>
    css`
      ${animateWidth} ${animationDuration / 1000}s linear forwards
    `};
  animation-play-state: ${({isProgressAnimationPaused}) =>
    isProgressAnimationPaused ? 'paused' : 'running'};
`;
